/*
 * @Author: yaodongyi
 * @Date: 2025-06-26 21:43:43
 * @LastEditors: yaodongyi
 * @LastEditTime: 2025-07-09 22:52:26
 * @Description: 独立支付
 */

import { api_getDomainInfoNew, api_preOrder, IGetDomainInfo } from "../api/payment";
import md5 from "blueimp-md5";

/** 独立支付 */
export const independentPayment = async (
  // 判断是否需要独立支付的参数
  independentOptions: IGetDomainInfo,
  // 支付相关参数
  payOptions: {
    trade_type: string;
    data: {
      params: any,
      invoice_id?: string | number
      appId?: string | number
    };
  },
) => {
  const { isIndependent, domain } = await api_getDomainInfoNew(independentOptions);
  if (isIndependent) {
    const _opt: { [key: string]: any } = {
      opt: JSON.stringify(payOptions.data.params) || "",
      trade_type: payOptions.trade_type || "",
      invoice_id: payOptions.data.invoice_id || "",
      appId: payOptions.data.appId || "",
    };
    // 接口参数字典按照键升序排序，加密盐：lizhiweike666，加密后取前8个字符根据盐加密对应的字典, 返回对应的md5字符串
    const sortOpt = Object.keys(_opt)
      .sort()
      .map((key) => `${key}=${_opt[key]}`)
      .join("&");
    _opt.pay_sign = md5(sortOpt + "lizhiweike666").slice(0, 8);

    try {
      // 存hash
      const res = await api_preOrder(_opt);
      // 跳转独立支付
      if (res.code === 0 && res.data && res.data.pay_hash_key) {
        const _join = domain && domain.endsWith("/") ? "" : "/";
        // 为了区分redirect_url，避免登录时出现冲突，这里使用back_url
        window.location.href = `${domain}${_join}weike-pay-fe/payment?pay_hash_key=${
          res.data.pay_hash_key
        }&back_url=${encodeURIComponent(window.location.href)}`;
        return Promise.resolve({ isIndependent, domain, data: res });
      } else {
        // 签名错误
        return Promise.reject({ isIndependent, domain, error: res });
      }
    } catch (error) {
      console.error(error);
      // 接口挂了
      return Promise.reject({ isIndependent, domain, error });
    }
  }
  // 需要增加埋点：是否走独立支付+支付用户id+支付产品+直播间id（便于查询异常问题）
  return { isIndependent };
};
